export default __webpack_public_path__ + "static/media/Euro.06ce68dd.svg";